import { Modal, Radio } from 'antd';
import Button from 'antd-button-color';
import DatePicker from '@/components/atoms/date/DatePicker';
import closeBtn from '@images/icon/btn_close_p.png';

export type ModalProps = {
  modalVisible: boolean;
  toggleModal?: () => void;
};

const SearchModal = ({ modalVisible, toggleModal }: ModalProps) => {
  // 모달 푸터영역
  const modalFooter = (
    <Button type="text" onClick={toggleModal}>
      엑셀다운로드
    </Button>
  );

  // 모달 닫기버튼
  const modalClosed = <img src={closeBtn} alt="팝업닫기" />;

  return (
    <Modal
      title="검색조건 설정"
      visible={modalVisible}
      centered
      width={380}
      onCancel={toggleModal}
      destroyOnClose
      footer={modalFooter}
      closeIcon={modalClosed}
      className="pincarbiz"
    >
      <div className="search-row__radio">
        <strong>구분</strong>
        <Radio.Group defaultValue="regist" buttonStyle="solid" className="radio-round-group">
          <Radio.Button value="regist">등록일</Radio.Button>
          <Radio.Button value="violation">위반일</Radio.Button>
        </Radio.Group>
      </div>
      <div className="search-row__radio">
        <strong>기간설정</strong>
        <Radio.Group buttonStyle="solid" className="radio-round-group">
          <Radio.Button value="one">1개월</Radio.Button>
          <Radio.Button value="two">2개월</Radio.Button>
          <Radio.Button value="three">3개월</Radio.Button>
          <Radio.Button value="input">직접입력</Radio.Button>
        </Radio.Group>
        {/* 직접입력 영역 */}
        <div className="range-select">
          <p>
            <DatePicker placeholder="시작일" />
            <span>~</span>
            <DatePicker placeholder="종료일" />
          </p>
          <span>
            <sup>*</sup>검색기간은 최대 3개월 입니다.
          </span>
        </div>
      </div>
    </Modal>
  );
};

SearchModal.defaultProps = {
  modalVisible: false,
};

export default SearchModal;
